import React from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { SecondaryButton } from '@bibliocommons/base-buttons';
import NotFound from '@bibliocommons/not-found';
import BasePageContainer from './BasePageContainer';
import AppActions from '../actions/AppActions';

class FeatureToggleContainer extends BasePageContainer {
  renderFlags() {
    const { dispatch, featureFlags } = this.props;
    return featureFlags.sortBy((value, flag) => flag.toLowerCase())
      .map((value, name) => (
        <tr className={cn({ success: value })}>
          <td>{name}</td>
          <td>
            <span className={cn('label', { 'label-danger': !value }, { 'label-success': value })} style={{ 'font-size': '1.2em' }}>
              {value ? 'YES' : 'NO'}
            </span>
          </td>
          <td>
            <SecondaryButton handleClick={() => dispatch(AppActions.updateFeatureFlag(name, !value))}>
              Toggle
            </SecondaryButton>
          </td>
        </tr>
      ));
  }
  render() {
    if (!this.props.allowsEditing) {
      return <NotFound />;
    }

    return (
      <table className="table table-striped table-condensed">
        <thead>
          <tr><th width="50%">Title</th><th width="30%">Enabled?</th><th width="20%">Action</th></tr>
        </thead>
        <tbody>
          {this.renderFlags()}
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => ({
  featureFlags: state.getIn(['app', 'featureFlags']),
  allowsEditing: state.getIn(['app', 'allowFeatureFlagEditing'], false)
});

export default connect(mapStateToProps)(FeatureToggleContainer);



// WEBPACK FOOTER //
// ./app/containers/FeatureToggleContainer.jsx